export default [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
